<template>
  <div class="item">
    <div class="tools">
      <div class="index">{{ index + 1 }}</div>
      <div class="btns">
        <img
          class="btn"
          @click="moveItemUp"
          src="@/assets/img/YanShiHuiBao/up.png"
          alt=""
        />
        <img
          class="btn"
          @click="moveItemDown"
          src="@/assets/img/YanShiHuiBao/down.png"
          alt=""
        />
        <img
          v-show="itemInfo.isShow"
          class="btn"
          @click="setShow(false)"
          src="@/assets/img/YanShiHuiBao/show.png"
          alt=""
        />
        <img
          v-show="!itemInfo.isShow"
          class="btn"
          @click="setShow(true)"
          src="@/assets/img/YanShiHuiBao/hide.png"
          alt=""
        />
        <img
          class="btn"
          @click="copyItem"
          src="@/assets/img/YanShiHuiBao/copy.png"
          alt=""
        />
        <img
          class="btn"
          @click="deleteItem"
          src="@/assets/img/YanShiHuiBao/delete.png"
          alt=""
        />
      </div>
    </div>
    <div class="main">
      <div class="img">
        <img :src="itemInfo.img" alt="" />
      </div>
      <div class="infos">
        <div class="info">
          <div class="point"></div>
          <div class="name">名称</div>
          <div class="values" v-show="!isEdit1">
            <div class="val">{{ itemInfo.name }}</div>
            <img
              @click="editValue('isEdit1', true)"
              src="@/assets/img/YanShiHuiBao/edit.png"
            />
          </div>
          <div class="edit" v-show="isEdit1">
            <input class="val" type="text" v-model="nameStr" />
            <img
              @click="editValueOk('isEdit1', true)"
              src="@/assets/img/YanShiHuiBao/ok.png"
            />
            <img
              @click="editValueOk('isEdit1', false)"
              src="@/assets/img/YanShiHuiBao/no.png"
            />
          </div>
        </div>
        <div class="info">
          <div class="point"></div>
          <div class="name">停留时长</div>
          <div class="values" v-show="!isEdit2">
            <div class="val">{{ itemInfo.delay }}</div>
            <img
              @click="editValue('isEdit2', true)"
              src="@/assets/img/YanShiHuiBao/edit.png"
            />
          </div>
          <div class="edit" v-show="isEdit2">
            <input class="val" type="text" v-model="delayStr" />
            <img
              @click="editValueOk('isEdit2', true)"
              src="@/assets/img/YanShiHuiBao/ok.png"
            />
            <img
              @click="editValueOk('isEdit2', false)"
              src="@/assets/img/YanShiHuiBao/no.png"
            />
          </div>
        </div>
        <div class="info">
          <div class="point"></div>
          <div class="name">动画时长</div>
          <div class="values" v-show="!isEdit3">
            <div class="val">{{ itemInfo.flyTime }}</div>
            <img
              @click="editValue('isEdit3', true)"
              src="@/assets/img/YanShiHuiBao/edit.png"
            />
          </div>
          <div class="edit" v-show="isEdit3">
            <input class="val" type="text" v-model="flyTimeStr" />
            <img
              @click="editValueOk('isEdit3', true)"
              src="@/assets/img/YanShiHuiBao/ok.png"
            />
            <img
              @click="editValueOk('isEdit3', false)"
              src="@/assets/img/YanShiHuiBao/no.png"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="explain">
      <div class="default" v-show="!isEditExplain">{{ itemInfo.explain }}</div>
      <div class="values" v-show="!isEditExplain">
        <img
          @click="editExplain('explainEdit', true)"
          src="@/assets/img/YanShiHuiBao/edit.png"
        />
      </div>
      <div class="edit" v-show="isEditExplain">
        <input class="val" type="text" v-model="explain" />
        <img
          @click="editExplainOk(true)"
          src="@/assets/img/YanShiHuiBao/ok.png"
        />
        <img
          @click="editExplainOk(false)"
          src="@/assets/img/YanShiHuiBao/no.png"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemInfo: {
      type: Object,
      default: () => {
        return {
          name: '',
          views: [],
        }
      },
    },
    index: {
      type: Number,
      default: 1,
    },
  },
  components: {},
  data() {
    return {
      isEdit1: false,
      isEdit2: false,
      isEdit3: false,
      isEditExplain: false,
      nameStr: '',
      delayStr: '',
      flyTimeStr: '',
      explain: '',
    }
  },
  methods: {
    moveItemUp() {
      this.$emit('moveItemUp', this.index)
    },
    moveItemDown() {
      this.$emit('moveItemDown', this.index)
    },
    setShow(flag) {
      this.$emit('setShow', this.index, flag)
    },
    copyItem() {
      this.$emit('copyItem', this.index)
    },
    deleteItem() {
      this.$emit('deleteItem', this.index)
    },
    editValue(data, flag) {
      this[data] = flag
      switch (data) {
        case 'isEdit1':
          this.nameStr = this.itemInfo.name
          break
        case 'isEdit2':
          this.delayStr = this.itemInfo.delay - 0
          break
        case 'isEdit3':
          this.flyTimeStr = this.itemInfo.flyTime - 0
          break
        default:
          break
      }
    },
    editValueOk(data, flag) {
      this[data] = false
      switch (data) {
        case 'isEdit1':
          if (flag) {
            this.itemInfo.name = this.nameStr
          }
          break
        case 'isEdit2':
          if (flag) {
            this.itemInfo.delay = this.delayStr - 0
          }
          break
        case 'isEdit3':
          if (flag) {
            this.itemInfo.flyTime = this.flyTimeStr - 0
          }
          break
      }
    },
    editExplain() {
      this.isEditExplain = true
      this.explain = this.itemInfo.explain
    },
    editExplainOk(flag) {
      this.isEditExplain = false
      if (flag) {
        this.itemInfo.explain = this.explain
      }
    },
  },

  mounted() {},
  // watch: {
  //   itemInfo: {
  //     handler(val) {
  //       this.nameStr = val.name
  //       this.delayStr = val.delay
  //       this.flyTimeStr = val.flyTime
  //       this.explain = val.explain
  //     },
  //     deep: true,
  //   },
  // },
}
</script>

<style scoped lang="less">
.item {
  height: 310px;
  .tools {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 58px;
    border-top: 1px #797f86 solid;
    box-sizing: border-box;
    padding: 0 28px;
    background-color: #3f4751;
    .index {
      font-size: 28px;
      color: #fff;
    }
    .btns {
      width: 210px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  .main {
    height: 195px;
    background-color: rgba(17, 21, 34, 0.6);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .img {
      width: 210px;
      height: 158px;
      overflow: hidden;
      border: 3px #9797a6 solid;
      margin-left: 28px;
      display: flex;
      background-color: #000;
      align-items: center;
      img {
        width: 100%;
      }
    }
    .infos {
      width: 370px;
      height: 158px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-right: 28px;
      .info {
        height: 45px;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: 26px;
        .point {
          width: 10px;
          height: 10px;
          background-color: #55b7ff;
          border-radius: 10px;
          margin-right: 10px;
        }
        .name {
          width: 120px;
        }
        .values {
          width: 230px;
          display: flex;
          justify-content: space-between;
          img {
            margin-left: 20px;
          }
          .val {
            width: 150px;
            text-align: right;
            overflow: hidden;
          }
        }
        .edit {
          width: 230px;
          display: flex;
          align-items: center;
          .val {
            width: 150px;
            white-space: nowrap;
            overflow: hidden;
            white-space: nowrap;
            height: 40px;
            background-color: #4b4e5a;
            text-align: right;
            border: none;
            outline: none;
            color: #fff;
            font-size: 26px;
            border-radius: 4px;
            box-sizing: border-box;
            padding-right: 4px;
          }
          img {
            margin-left: 15px;
          }
        }
      }
    }
  }
  .explain {
    height: 50px;
    background-color: #111522;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 28px;
    border-bottom: 1px #ccc solid;
    .default {
      width: 540px;
      color: #fff;
      font-size: 26px;
    }
    .edit {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .val {
      width: 545px;
      overflow: hidden;
      white-space: nowrap;
      color: #fff;
      font-size: 26px;
      height: 40px;
      background-color: #4b4e5a;
      text-align: left;
      border: none;
      outline: none;
      color: #fff;
      font-size: 26px;
      border-radius: 4px;
      box-sizing: border-box;
      text-indent: 4px;
      line-height: 40px;
    }
  }
}
</style>
